export default __webpack_public_path__ + "static/media/homePageAdvanced.b7477f8d.png";